
/*
 * PAWS & PEARLS
 * SECRET SKY — DISTANT WATER V1
 *
 * An independent, very quiet water ambience.
 * Leaves all existing animations and sounds intact.
 */

(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector(
      'script[data-pp-muse-distant-water-v1]'
    );

  var url = script &&
    script.getAttribute('data-water-src');

  if (
    !url ||
    !/^(https?:\/\/|\/)/.test(url)
  ) return;

  // MADAM'S ADJUSTABLE SETTINGS

  var PEAK_VOLUME = 0.15;

  var IDLE_VOLUME = 0.001;

  var FADE_IN_START_MS = 4000;
  var FADE_IN_END_MS = 12000;

  var FADE_OUT_START_MS = 72000;
  var END_MS = 83000;

  var stage, sky, balloon, player;

  var timer = 0;
  var startedAt = 0;

  var running = false;
  var disposed = false;
  var visibilityGain = 0;

  function houseAllowsSound() {
    var house = window.ppHouseSound;

    if (
      !house ||
      typeof house.isEnabled !== 'function'
    ) return false;

    try {
      return house.isEnabled() === true;
    } catch (_error) {
      return false;
    }
  }

  function skyInView() {
    if (!sky || !sky.isConnected) return false;

    var r = sky.getBoundingClientRect();

    var wrapper = document.querySelector(
      '.page-wrapper'
    );

    var w = wrapper
      ? wrapper.getBoundingClientRect()
      : {
          left: 0,
          right: window.innerWidth,
          top: 0,
          bottom: window.innerHeight
        };

    return (
      r.width > 0 &&
      r.height > 0 &&
      r.right > Math.max(0, w.left) &&
      r.left < Math.min(window.innerWidth, w.right) &&
      r.bottom > Math.max(0, w.top) &&
      r.top < Math.min(window.innerHeight, w.bottom)
    );
  }

  function stop() {
    running = false;

    if (timer) {
      clearInterval(timer);
      timer = 0;
    }

    if (player) {
      try {
        player.volume = IDLE_VOLUME;
        player.pause();
        player.currentTime = 0;
      } catch (_error) {}
    }
  }

  function tick() {
    if (!running || disposed) return;

    if (
      !houseAllowsSound() ||
      document.hidden
    ) {
      stop();
      return;
    }

    var ms = performance.now() - startedAt;

    if (
      ms >= END_MS ||
      !player ||
      player.ended
    ) {
      stop();
      return;
    }

    var fadeIn = Math.max(
      0,
      Math.min(
        1,
        (ms - FADE_IN_START_MS) /
          (FADE_IN_END_MS - FADE_IN_START_MS)
      )
    );

    var fadeOut = Math.max(
      0,
      Math.min(
        1,
        (END_MS - ms) /
          (END_MS - FADE_OUT_START_MS)
      )
    );

    // Water softens when the visitor
    // scrolls away from Secret Sky.

    visibilityGain += (
      (skyInView() ? 1 : 0) -
      visibilityGain
    ) * 0.16;

    var gain =
      Math.min(fadeIn, fadeOut) *
      visibilityGain;

    player.volume = Math.min(
      1,
      Math.max(
        0,
        IDLE_VOLUME +
          (PEAK_VOLUME - IDLE_VOLUME) *
          gain
      )
    );
  }

  function onBalloonClick() {
    if (
      disposed ||
      running ||
      !houseAllowsSound()
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    if (!player) {
      player = new Audio(url);

      player.preload = 'auto';

      // The entire 86-second recording
      // plays once. No repeated waves.

      player.loop = false;
    }

    try {
      player.pause();
      player.currentTime = 0;
      player.volume = IDLE_VOLUME;

      visibilityGain = 0;
      startedAt = performance.now();

      running = true;

      // Start during the visitor's genuine
      // balloon click for Safari.

      var promise = player.play();

      if (
        promise &&
        typeof promise.catch === 'function'
      ) {
        promise.catch(function (error) {
          if (!running) return;

          console.warn(
            '[P&P Distant Water] Audio unavailable:',
            error
          );

          stop();
        });
      }

      timer = setInterval(tick, 100);

    } catch (error) {
      console.warn(
        '[P&P Distant Water] Could not start:',
        error
      );

      stop();
    }
  }

  function onSoundChange() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibilityChange() {
    if (document.hidden) stop();
  }

  function onSectionUnload(event) {
    if (
      !event.target ||
      !event.target.contains(stage)
    ) return;

    disposed = true;
    stop();

    balloon.removeEventListener(
      'click',
      onBalloonClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onSoundChange
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onSoundChange
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.removeEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.removeEventListener(
      'pagehide',
      stop
    );
  }

  function init() {
    if (
      !document.documentElement.classList.contains(
        'pp-muse-secret-sky-page'
      )
    ) return;

    stage = document.getElementById(
      'pp-muse-balloon-stage'
    );

    sky = document.getElementById(
      'pp-muse-secret-sky'
    );

    balloon = stage &&
      stage.querySelector('button.pp-balloon');

    if (
      !stage ||
      !sky ||
      !balloon ||
      stage.dataset.ppDistantWaterV1 === '1'
    ) return;

    stage.dataset.ppDistantWaterV1 = '1';

    balloon.addEventListener(
      'click',
      onBalloonClick
    );

    document.addEventListener(
      'pp:house-sound-change',
      onSoundChange
    );

    window.addEventListener(
      'pp:house-sound-change',
      onSoundChange
    );

    document.addEventListener(
      'visibilitychange',
      onVisibilityChange
    );

    document.addEventListener(
      'shopify:section:unload',
      onSectionUnload
    );

    window.addEventListener(
      'pagehide',
      stop
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();
